import React from "react";
import { graphql } from "gatsby";
import Seo from "gatsby-plugin-wpgraphql-seo";
import { Layout, Banner } from "../components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const SingleDoctor = ({
  content,
  data: {
    wp: {
      acfOptionsHeader: {
        siteHeader: { doctorsPageBanner },
      },
    },
    wpDoctor,
    wpDoctor: { doctorsMeta },
  },
}) => {
  const doctorImage = getImage(
    doctorsMeta?.profilePic?.localFile?.childImageSharp?.gatsbyImageData
  );
  return (
    <>
      <Seo post={wpDoctor} />
      <Layout>
        <Banner banner={doctorsPageBanner} />
        <section className="bg-white py-16">
          <div className="container mx-auto">
            <div className="flex px-4">
              <h2 className=" mb-8 w-full basis-full text-center font-openSans text-4xl capitalize text-secondary">
                Doctors Profiling
              </h2>
            </div>
            <div className="flex flex-wrap">
              <div className="w-full basis-full px-4 lg:w-1/4 lg:basis-1/4">
                <GatsbyImage image={doctorImage} alt="" />
                <h3 className="mt-4 font-openSans text-2xl capitalize text-primary">
                  {wpDoctor.title}
                </h3>
                <p className="font-openSans text-xl capitalize text-black">
                  {doctorsMeta.designation}
                </p>
              </div>
              <div className="w-full basis-full lg:w-3/4 lg:basis-3/4">
                {(doctorsMeta.degree ||
                  doctorsMeta.institution ||
                  doctorsMeta.yearOfPassing) && (
                  <h3 className="mb-4 px-4 font-openSans text-2xl capitalize text-primary">
                    Education
                  </h3>
                )}
                <div className="flex flex-row flex-wrap">
                  {doctorsMeta.degree && (
                    <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                      <h4 className="mb-2 font-openSans text-2xl capitalize text-primary">
                        Degree
                      </h4>
                      <p className="mb-4 font-openSans text-xl text-black">
                        {doctorsMeta.degree}
                      </p>
                    </div>
                  )}
                  {doctorsMeta.institution && (
                    <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                      <h4 className="mb-2 font-openSans text-2xl capitalize text-primary">
                        Institution
                      </h4>
                      <p className="mb-4 font-openSans text-xl text-black">
                        {doctorsMeta.institution}
                      </p>
                    </div>
                  )}
                  {doctorsMeta.yearOfPassing && (
                    <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                      <h4 className="mb-2 font-openSans text-2xl capitalize text-primary">
                        Year of Passing
                      </h4>
                      <p className="mb-4 font-openSans text-xl text-black">
                        {doctorsMeta.yearOfPassing}
                      </p>
                    </div>
                  )}
                </div>
                <div className="flex flex-row flex-wrap">
                  {doctorsMeta.branch && (
                    <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                      <h3 className="mb-2 font-openSans text-2xl capitalize text-primary">
                        Branch
                      </h3>
                      <p className="mb-4 font-openSans text-xl text-black">
                        <a href={doctorsMeta.branch.uri}>
                          {doctorsMeta.branch.title}
                        </a>
                      </p>
                    </div>
                  )}
                  {doctorsMeta.experience && (
                    <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                      <h3 className="mb-2 font-openSans text-2xl capitalize text-primary">
                        Experience
                      </h3>
                      <p className="mb-4 font-openSans text-xl text-black">
                        {doctorsMeta.experience}
                      </p>
                    </div>
                  )}
                </div>
                {doctorsMeta.department && (
                  <div className="w-full basis-full px-4">
                    <h3 className="mb-2 font-openSans text-2xl capitalize text-primary">
                      Department
                    </h3>
                    <p className="mb-4 font-openSans text-xl text-black">
                      {doctorsMeta.department}
                    </p>
                  </div>
                )}
                {doctorsMeta.areasOfExpertise && (
                  <div className="w-full basis-full px-4">
                    <h3 className="mb-2 font-openSans text-2xl capitalize text-primary">
                      Area of Expertise
                    </h3>
                    <p
                      className="page-content mb-4 font-openSans text-xl text-black"
                      dangerouslySetInnerHTML={{
                        __html: doctorsMeta.areasOfExpertise,
                      }}
                    ></p>
                  </div>
                )}
                {doctorsMeta.awardsAndAccoladed && (
                  <div className="w-full basis-full px-4">
                    <h3 className="font-openSans text-2xl capitalize text-primary">
                      Awards & Accoladed
                    </h3>
                    <p
                      className="page-content mb-4 font-openSans text-xl text-black"
                      dangerouslySetInnerHTML={{
                        __html: doctorsMeta.awardsAndAccoladed,
                      }}
                    ></p>
                  </div>
                )}
                {doctorsMeta.memberships && (
                  <div className="w-full basis-full px-4">
                    <h3 className="font-openSans text-2xl capitalize text-primary">
                      Memberships
                    </h3>
                    <p
                      className="page-content mb-4 font-openSans text-xl text-black"
                      dangerouslySetInnerHTML={{
                        __html: doctorsMeta.memberships,
                      }}
                    ></p>
                  </div>
                )}
                {doctorsMeta.researchAndPublications && (
                  <div className="w-full basis-full px-4">
                    <h3 className="font-openSans text-2xl capitalize text-primary">
                      Research & Publications
                    </h3>
                    <p
                      className="page-content mb-4 font-openSans text-xl text-black"
                      dangerouslySetInnerHTML={{
                        __html: doctorsMeta.researchAndPublications,
                      }}
                    ></p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default SingleDoctor;

export const query = graphql`
  query DoctorQuery($id: Int) {
    wpDoctor(databaseId: { eq: $id }) {
      title
      doctorsMeta {
        areasOfExpertise
        awardsAndAccolades
        branch {
          ... on WpCentre {
            title
            uri
          }
        }
        degree
        experience
        institution
        memberships
        designation
        department
        researchAndPublications
        yearOfPassing
        profilePic {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
            }
          }
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
    wp {
      acfOptionsHeader {
        siteHeader {
          doctorsPageBanner {
            buttonLabel
            buttonLink
            captionContent
            captionTitle
            desktopImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            position
            showWhiteLogo
            whiteColor
          }
        }
      }
    }
  }
`;
